import apiService from '@/api/apiService';

export const roleList = async (pageSize, pageIndex) => {
    const url = '/api/admin/roles';

    // 建立查詢參數的物件
    const queryParams = {
        page: pageIndex,
        page_size: pageSize
    };

    // 將物件轉換為 URL 參數
    const params = new URLSearchParams(queryParams);

    return apiService.GET(`${url}?${params.toString()}`);
};
